import React, { useState } from "react";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  FormGroup,
  Label,
  Input,
} from "reactstrap";
import { getDb } from "../../../util/Constants";
import { collection, addDoc } from "firebase/firestore";
import Swal from "sweetalert2";

export default function AddMiniGame6Modal({ isOpen, toggle, onQuestionAdded }) {
  const [paragraph, setParagraph] = useState("");
  const [mcqs, setMCQs] = useState([]);
  const [correctAnswer, setCorrectAnswer] = useState("");
  const [loading, setLoading] = useState(false);

  const resetFields = () => {
    setParagraph("");
    setMCQs([]);
    setCorrectAnswer("");
  };

  const handleSubmit = async () => {
    if (!paragraph.trim() || mcqs.length === 0 || !correctAnswer.trim()) {
      Swal.fire("Error", "Please fill all fields.", "error");
      return;
    }
    setLoading(true);
    try {
      await addDoc(collection(getDb(), "questions"), {
        miniGame: "Mini 6",
        paragraph: paragraph.trim(),
        mcqs,
        correctAnswer: correctAnswer.trim(),
      });
      Swal.fire("Success", "Question added!", "success");
      resetFields();
      toggle();
      if (onQuestionAdded) onQuestionAdded();
    } catch (error) {
      Swal.fire("Error", "Failed to add question.", "error");
    }
    setLoading(false);
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle} centered>
      <ModalHeader toggle={toggle}>Add MiniGame 6 Question</ModalHeader>
      <ModalBody>
        <FormGroup>
          <Label>Paragraph</Label>
          <Input
            type="textarea"
            value={paragraph}
            onChange={(e) => setParagraph(e.target.value)}
            rows={5}
            placeholder="Enter paragraph"
          />
        </FormGroup>
        <FormGroup>
          <Label>MCQ Options (one per line)</Label>
          <Input
            type="textarea"
            value={mcqs.join("\n")}
            onChange={(e) => setMCQs(e.target.value.split("\n"))}
            rows={4}
            placeholder="Enter options, one per line"
          />
        </FormGroup>
        <FormGroup>
          <Label>Correct Answer</Label>
          <Input
            type="text"
            value={correctAnswer}
            onChange={(e) => setCorrectAnswer(e.target.value)}
            placeholder="Enter correct answer"
          />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit} disabled={loading}>
          {loading ? "Adding..." : "Add"}
        </Button>
        <Button color="secondary" onClick={toggle} disabled={loading}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
}
